export const routers = [
    {
        // 通讯录
        name: 'addressList',
        router: [{
            path: '/home',
            name: 'home',
            component: () => import('@/views/salesTerminal/addressBook/index.vue'),
        }, {
            // 添加联系人
            path: '/addContact',
            name: 'addContact',
            component: () => import('@/views/salesTerminal/addressBook/addContact.vue'),
            meta: {
                keepAlive: true, // 需要缓存
                componentName: 'add-contact',
                hierarchy: 0,
            },
        }, {
            // 联系人
            path: '/contacts',
            name: 'contacts',
            component: () => import('@/views/salesTerminal/addressBook/contacts.vue'),
            meta: {
                keepAlive: true, // 需要缓存
                componentName: 'contacts',
                hierarchy: 1,
            },
        }, {
            // 新增群组选择人员
            path: '/newGroup',
            name: 'newGroup',
            component: () => import('@/views/salesTerminal/addressBook/newGroup.vue'),
        }, {
            // 联系人信息
            path: '/contactInfo',
            name: 'contactInfo',
            component: () => import('@/views/salesTerminal/addressBook/contactInfo.vue'),
        }],
    }, {
        // 销售端
        name: 40,
        router: [
            {
                path: '/home',
                name: 'home',
                component: () => import('@/views/home/home_xs.vue'),
            },
            // 发货单核对列表
            {
                path: '/invoiceCheck',
                name: 'invoiceCheck',
                component: () => import('@/views/salesTerminal/invoiceCheck/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'invoice-check',
                    hierarchy: 0,
                },
            },
            // 缺失发货单
            {
                path: '/missingInvoice',
                name: 'missingInvoice',
                component: () => import('@/views/salesTerminal/invoiceCheck/missingInvoice.vue'),
            },
            // 调整签收方量单数
            {
                path: '/changeInvoiceNumber',
                name: 'changeInvoiceNumber',
                component: () => import('@/views/salesTerminal/invoiceCheck/changeInvoiceNumber.vue'),
            },
            // 扫码核对
            {
                path: '/scanCodeCheck',
                name: 'scanCodeCheck',
                component: () => import('@/views/salesTerminal/invoiceCheck/scanCodeCheck.vue'),
            },
            // 线索登记
            {
                path: '/clueRegistration',
                name: 'clueRegistration',
                component: () => import('@/views/salesTerminal/clueRegistration/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'clue-registration',
                    hierarchy: 0,
                },
            },
            // 线索登记-选择公司
            {
                path: '/selectCompany',
                name: 'selectCompany',
                component: () => import('@/views/salesTerminal/clueRegistration/selectCompany.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'select-company',
                    hierarchy: 1,
                },
            },

            // 线索登记-选择工程性质
            {
                path: '/selectProjectCategory',
                name: 'selectProjectCategory',
                component: () => import('@/views/salesTerminal/clueRegistration/selectProjectCategory.vue'),
            },
            // 工程位置
            {
                path: '/ProjectLocation',
                name: 'ProjectLocation',
                component: () => import('@/views/salesTerminal/salesComponents/projectAddress.vue'),
            },


            // 线索跟踪
            {
                path: '/clueManagement',
                name: 'clueManagement',
                component: () => import('@/views/salesTerminal/clueManagement/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'clue-management',
                    hierarchy: 0,
                },
            },
            // 线索详情
            {
                path: '/clueDetails',
                name: 'clueDetails',
                component: () => import('@/views/salesTerminal/clueManagement/clueDetails.vue'),
            },
            // 线索记录
            {
                path: '/clueRecord',
                name: 'clueRecord',
                component: () => import('@/views/salesTerminal/clueManagement/clueRecord.vue'),
            },

            // 客户管理
            {
                path: '/customerManagement',
                name: 'customerManagement',
                component: () => import('@/views/salesTerminal/customerManagement/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'customer-management',
                    hierarchy: 0,
                },
            },
            // 客户管理-关联工程信息列表
            {
                path: '/engineerList',
                name: 'engineerList',
                component: () => import('@/views/salesTerminal/customerManagement/engineerList.vue'),
            },
            // 客户管理-关联工程合同信息列表
            {
                path: '/contractList',
                name: 'contractList',
                component: () => import('@/views/salesTerminal/customerManagement/contractList.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'contract-list',
                    hierarchy: 0,
                },
            },
            // 潜在客户录入
            {
                path: '/customerEntry',
                name: 'customerEntry',
                component: () => import('@/views/salesTerminal/customerManagement/customerEntry.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'customer-entry',
                    hierarchy: 1,
                },
            },
            // 关联企业
            {
                path: '/affiliatedEnterprises',
                name: 'affiliatedEnterprises',
                component: () => import('@/views/salesTerminal/customerManagement/affiliatedEnterprises.vue'),
            },

            // 客户管理-领导
            {
                path: '/customerManagement_leader',
                name: 'customerManagement_leader',
                component: () => import('@/views/salesTerminal/customerManagement_leader/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'customer-management-leader',
                    hierarchy: 0,
                },
            },
            // 潜在客户录入
            {
                path: '/customerEntry_leader',
                name: 'customerEntry_leader',
                component: () => import('@/views/salesTerminal/customerManagement_leader/customerEntry.vue'),
            },


            // 合同信息
            {
                path: '/contractInfo',
                name: 'contractInfo',
                component: () => import('@/views/salesTerminal/contractInfo/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'contract-info',
                    hierarchy: 0,
                },
            },
            // 合同档案
            {
                path: '/contractAchrives',
                name: 'contractAchrives',
                component: () => import('@/views/salesTerminal/contractInfo/contractAchrives/default.vue'),
                // meta: {
                //     keepAlive: true, // 需要缓存
                //     componentName: 'contract-achrives',
                //     hierarchy: 1,
                // },
            },
            // 合同管控数据
            {
                path: '/controlData',
                name: 'controlData',
                component: () => import('@/views/salesTerminal/contractInfo/controlData/index.vue'),
                // meta: {
                //     keepAlive: true, // 需要缓存
                //     componentName: 'control-data',
                //     hierarchy: 1,
                // },
            },

            // 合同详情
            {
                path: '/contractDetails',
                name: 'contractDetails',
                component: () => import('@/views/salesTerminal/contractInfo/contractDetails.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'contract-details',
                    hierarchy: 1,
                },
            },
            // 合同详情-基础版
            {
                path: '/contractDetailsBasics',
                name: 'contractDetailsBasics',
                component: () => import('@/views/salesTerminal/contractInfo/contractDetails_Basics.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'contract-details-basics',
                    hierarchy: 1,
                },
            },
            // 查看地址
            {
                path: '/locationInfo',
                name: 'locationInfo',
                component: () => import('@/views/map/locationInfo.vue'),
            },
            // 表单
            {
                path: '/FormView',
                name: 'FormView',
                component: () => import('@/views/salesTerminal/contractInfo/FormView.vue'),
            },
            // 附件预览
            {
                path: '/attachmentView',
                name: 'attachmentView',
                component: () => import('@/views/salesTerminal/contractInfo/attachmentView.vue'),
            },

            // 客户信息
            {
                path: '/customerInfo',
                name: 'customerInfo',
                component: () => import('@/views/salesTerminal/contractInfo/customerInfo.vue'),
            },

            // 合同进度
            {
                path: '/contractProgress',
                name: 'contractProgress',
                component: () => import('@/views/salesTerminal/contractProgress/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'contract-progress',
                    hierarchy: 0,
                },
            },
            // 工程进度 、 单体进度
            {
                path: '/schedule',
                name: 'schedule',
                component: () => import('@/views/salesTerminal/contractProgress/schedule.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'schedule',
                    hierarchy: 1,
                },
            },
            // 单体详情
            {
                path: '/monomerDetails',
                name: 'monomerDetails',
                component: () => import('@/views/salesTerminal/contractProgress/monomerDetails.vue'),
            },
            // 选择施工阶段
            {
                path: '/constructionSelect',
                name: 'constructionSelect',
                component: () => import('@/views/salesTerminal/contractProgress/constructionSelect.vue'),
            },
            // 添加工程进度
            {
                path: '/addEngineering',
                name: 'addEngineering',
                component: () => import('@/views/salesTerminal/contractProgress/addEngineering.vue'),
            },
            // 供应方量
            {
                path: '/supplyVolume',
                name: 'supplyVolume',
                component: () => import('@/views/salesTerminal/contractProgress/supplyVolume.vue'),
                meta: {
                    keepAlive: true,
                    componentName: 'supply-volume',
                    hierarchy: 1,
                },
            },
            // 供应方量-发货单列表
            {
                path: '/invoiceList',
                name: 'invoiceList',
                component: () => import('@/views/salesTerminal/contractProgress/invoiceList.vue'),
                meta: {
                    keepAlive: true,
                    componentName: 'supply-volume',
                    hierarchy: 1,
                },
            },
            // 往期查询
            {
                path: '/previousQuery',
                name: 'previousQuery',
                component: () => import('@/views/salesTerminal/contractProgress/previousQuery.vue'),
            },
            // 回款进度
            {
                path: '/refundSchedule',
                name: 'refundSchedule',
                component: () => import('@/views/salesTerminal/contractProgress/refundSchedule.vue'),
            },
            // 超限发货
            {
                path: '/overDelivery',
                name: 'overDelivery',
                component: () => import('@/views/salesTerminal/contractProgress/overDelivery.vue'),
            },
            // 合同进度详情
            {
                path: '/contractProgressDetails',
                name: 'contractProgressDetails',
                component: () => import('@/views/salesTerminal/contractProgress/contractDetails.vue'),
            },


            // 合同审批
            {
                path: '/contractApproval',
                name: 'contractApproval',
                component: () => import('@/views/salesTerminal/contractApproval/index.vue'),
                meta: {
                    keepAlive: true,
                    componentName: 'contract-approval',
                    hierarchy: 0,
                },
            },
            // 审批办理
            {
                path: '/approvalProcess',
                name: 'approvalProcess',
                component: () => import('@/views/salesTerminal/contractApproval/approvalProcess.vue'),
                meta: {
                    keepAlive: true,
                    componentName: 'approval-process',
                    hierarchy: 1,
                },
            },
            // 表单预览
            {
                path: '/formPreview',
                name: 'formPreview',
                component: () => import('@/views/salesTerminal/salesComponents/FormView.vue'),
            },
            // 信息价表单预览，【信息价有多个表单，通过接口跳转指定表单】
            {
                path: '/informationPriceView',
                name: 'informationPriceView',
                component: () => import('@/views/salesTerminal/contractApproval/informationPriceView.vue'),
            },
            // 提交
            {
                path: '/submission',
                name: 'submission',
                component: () => import('@/views/salesTerminal/contractApproval/submission.vue'),
            },
            // 审批意见
            {
                path: '/approvalComments',
                name: 'approvalComments',
                component: () => import('@/views/salesTerminal/contractApproval/approvalComments.vue'),
            },
            // 合同汇总资料【当前流程所有附件】
            {
                path: '/allProcedureAnnex',
                name: 'allProcedureAnnex',
                component: () => import('@/views/salesTerminal/contractApproval/allProcedureAnnex.vue'),
                meta: {
                    keepAlive: true,
                    componentName: 'all-procedure-annex',
                    hierarchy: 2,
                },
            },
            // 附件预览
            {
                path: '/attachmentPreview',
                name: 'attachmentPreview',
                component: () => import('@/views/salesTerminal/salesComponents/attachmentPreview.vue'),
            },


            // 用料统计
            {
                path: '/materialStatistics',
                name: 'materialStatistics',
                component: () => import('@/views/salesTerminal/materialStatistics/index.vue'),
            },


            // 订单下发
            {
                path: '/orderIssue',
                name: 'orderIssue',
                component: () => import('@/views/salesTerminal/orderIssue/index.vue'),
                meta: {
                    keepAlive: true,
                    componentName: 'order-issue',
                    hierarchy: 1,
                },
            },
            // 生产任务
            {
                path: '/productionTask',
                name: 'productionTask',
                component: () => import('@/views/salesTerminal/orderIssue/productionTask.vue'),
            },


            // 订单确认、零售订单确认
            {
                path: '/orderConfirmation',
                name: 'orderConfirmation',
                component: () => import('@/views/salesTerminal/orderConfirmation/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'order-confirmation',
                    hierarchy: 0,
                },
            },
            // 订单详情
            {
                path: '/orderDetails',
                name: 'orderDetails',
                component: () => import('@/views/salesTerminal/orderConfirmation/orderDetails.vue'),
            },


            // 超限发货
            {
                path: '/overApplication',
                name: 'overApplication',
                component: () => import('@/views/salesTerminal/overApplication/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'over-application',
                    hierarchy: 0,
                },
            },
            // 超发申请-新增
            {
                path: '/newOverApplication',
                name: 'newOverApplication',
                component: () => import('@/views/salesTerminal/overApplication/newOverApplication.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'new-over-application',
                    hierarchy: 1,
                },
            },
            // 新超限发货表单
            {
                path: '/overrunDeliverGoodsForm',
                name: 'overrunDeliverGoodsForm',
                component: () => import('@/views/salesTerminal/overApplication/overrunDeliverGoodsForm.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'overrun-deliver-goods-form',
                    hierarchy: 2,
                },
            },
            // 超发申请-选择合同
            {
                path: '/overContractList',
                name: 'overContractList',
                component: () => import('@/views/salesTerminal/overApplication/overContractList.vue'),
            },
            // 超发申请-合同详情
            {
                path: '/overContractInfo',
                name: 'overContractInfo',
                component: () => import('@/views/salesTerminal/overApplication/overContractInfo.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'over-contract-info',
                    hierarchy: 3,
                },
            },

            // 决策支持
            {
                path: '/decisionSupport',
                name: 'decisionSupport',
                component: () => import('@/views/salesTerminal/decisionSupport/index.vue'),
            },


            // 统计分析
            {
                path: '/statisticalAnalysis',
                name: 'statisticalAnalysis',
                component: () => import('@/views/salesTerminal/statisticalAnalysis/default.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'statistical-analysis',
                    hierarchy: 0,
                },
            },
            // 销售统计
            {
                path: '/saleStatistical',
                name: 'saleStatistical',
                component: () => import('@/views/salesTerminal/statisticalAnalysis/index.vue'),
            },
            // 每日数据
            {
                path: '/daydata',
                name: 'daydata',
                component: () => import('@/views/salesTerminal/statisticalAnalysis/Daydata.vue'),
            },
            // 每日数据新
            {
                path: '/newDaydata',
                name: 'newDaydata',
                component: () => import('@/views/salesTerminal/statisticalAnalysis/newDaydata.vue'),
            },
            // 明日计划
            {
                path: '/planTomorrow',
                name: 'planTomorrow',
                component: () => import('@/views/salesTerminal/statisticalAnalysis/planTomorrow.vue'),
            },
            // 应收账款
            {
                path: '/accountsReceive',
                name: 'accountsReceive',
                component: () => import('@/views/salesTerminal/statisticalAnalysis/accountsReceive/index.vue'),
            },
            // 采购日报
            {
                path: '/purchaseDaily',
                name: 'purchaseDaily',
                component: () => import('@/views/salesTerminal/statisticalAnalysis/PurchaseDaily.vue'),
            },
            // 消耗统计
            {
                path: '/productConsumIndex',
                name: 'productConsumIndex',
                component: () => import('@/views/salesTerminal/statisticalAnalysis/productConsumIndex.vue'),
            },
            // 销售日报-销售日报表
            {
                path: '/SalesReport',
                name: 'SalesReport',
                component: () => import('@/views/salesTerminal/statisticalAnalysis/SalesReport.vue'),
            },
            // 材料成本
            {
                path: '/materialCost',
                name: 'materialCost',
                component: () => import('@/views/salesTerminal/statisticalAnalysis/materialCost/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'material-cost',
                    hierarchy: 1,
                },
            },
            // 材料成本详情
            {
                path: '/materialCostDetails',
                name: 'materialCostDetails',
                component: () => import('@/views/salesTerminal/statisticalAnalysis/materialCost/materialCostDetails.vue'),
            },


            // 用料计划-列表
            {
                path: '/materialPlan',
                name: 'materialPlan',
                component: () => import('@/views/customerTerminal/materialPlan/materialPlan.vue'),
            },
            // 新增用料计划
            {
                path: '/newMaterialPlan',
                name: 'newMaterialPlan',
                component: () => import('@/views/customerTerminal/materialPlan/newMaterialPlan.vue'),
            },
            // 用料计划详情
            {
                path: '/materialPlanInfo',
                name: 'materialPlanInfo',
                component: () => import('@/views/customerTerminal/materialPlan/materialPlanInfo.vue'),
            },
            // 选择工程
            {
                path: '/selectProject',
                name: 'selectProject',
                component: () => import('@/views/customerTerminal/materialPlan/selectProject.vue'),
            },
            {
                path: '/selectConstructionEnterprise', // 选择施工单位
                name: 'selectConstructionEnterprise',
                component: () => import('@/views/customerTerminal/materialPlan/selectConstructionEnterprise.vue'),
            },
            // 选择单体
            {
                path: '/selectMonomer',
                name: 'selectMonomer',
                component: () => import('@/views/customerTerminal/materialPlan/selectMonomer.vue'),
            },
            // 交付评价-运输单列表
            {
                path: '/transSheet',
                name: 'transSheet',
                component: () => import('@/views/customerTerminal/materialPlan/transSheet.vue'),
            },
            // 新增-运输单
            {
                path: '/newTransSheet',
                name: 'newTransSheet',
                component: () => import('@/views/customerTerminal/materialPlan/newTransSheet.vue'),
            },
            // 电子运单
            {
                path: '/electronicTicket',
                name: 'electronicTicket',
                component: () => import('@/views/customerTerminal/materialPlan/electronicTicket.vue'),
            },
            // 工程信息
            {
                path: '/projectAddress',
                name: 'projectAddress',
                component: () => import('@/views/customerTerminal/materialPlan/projectAddress.vue'),
            },

            //  质量监控
            {
                path: '/qualityInspection',
                name: 'qualityInspection',
                component: () => import('@/views/salesTerminal/qualityInspection/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'quality-inspection',
                    hierarchy: 0,
                },
            },
            //  检测详情
            {
                path: '/testDetails',
                name: 'testDetails',
                component: () => import('@/views/salesTerminal/qualityInspection/testDetails.vue'),
            },
            //  快检重新选择供应单
            {
                path: '/selectSupply',
                name: 'selectSupply',
                component: () => import('@/views/salesTerminal/qualityInspection/selectSupply.vue'),
            },
            //  零售业务台账-列表
            {
                path: '/retailAccountList',
                name: 'retailAccountList',
                component: () => import('@/views/salesTerminal/retailAccount/retailAccountList.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'retail-account-list',
                    hierarchy: 0,
                },
            },
            //  零售业务台账-新建
            {
                path: '/newRetailAccount',
                name: 'newRetailAccount',
                component: () => import('@/views/salesTerminal/retailAccount/newRetailAccount.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'new-retail-account',
                    hierarchy: 0,
                },
            },
            //  零售业务台账-维护
            {
                path: '/retailAccountMaintain',
                name: 'retailAccountMaintain',
                component: () => import('@/views/salesTerminal/retailAccount/retailAccountMaintain.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'retail-account-maintain',
                    hierarchy: 0,
                },
            },
            //  零售业务台账-再下订单
            {
                path: '/placeAnotherOrder',
                name: 'placeAnotherOrder',
                component: () => import('@/views/salesTerminal/retailAccount/placeAnotherOrder.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'place-another-order',
                    hierarchy: 1,
                },
            },
            //  零售业务台账-维护
            {
                path: '/newMaintain',
                name: 'newMaintain',
                component: () => import('@/views/salesTerminal/retailAccount/newMaintain.vue'),
            },
            //  零售业务台账-选取附件型号
            {
                path: '/selectAdditionalModel',
                name: 'selectAdditionalModel',
                component: () => import('@/views/salesTerminal/retailAccount/selectAdditionalModel.vue'),
            },
            //  零售业务台账-工程地址
            {
                path: '/projectAddress', // 工程信息
                name: 'projectAddress',
                component: () => import('@/views/customerTerminal/materialPlan/projectAddress.vue'),
            },
            //  零售业务台账-选择业务员
            {
                path: '/selectSalesman', // 业务员
                name: 'selectSalesman',
                component: () => import('@/views/salesTerminal/retailAccount/selectSalesman.vue'),
            },
            //  零售业务台账-业务详情
            {
                path: '/retailAccountInfo',
                name: 'retailAccountInfo',
                component: () => import('@/views/salesTerminal/retailAccount/retailAccountInfo.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'retail-account-info',
                    hierarchy: 0,
                },
            },
            //  零售业务台账-上传附件
            {
                path: '/fileUpload',
                name: 'fileUpload',
                component: () => import('@/views/salesTerminal/retailAccount/fileUpload.vue'),
            },
            // 订单进度-列表
            {
                path: '/orderSituationList',
                name: 'orderSituationList',
                component: () => import('@/views/salesTerminal/orderSituation/orderList/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'order-situation-list',
                    hierarchy: 0,
                },
            },
            // 订单进度-运输单列表
            {
                path: '/transOrderlist',
                name: 'transOrderlist',
                component: () => import('@/views/salesTerminal/orderSituation/transOrderlist.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'trans-orderlist',
                    hierarchy: 1,
                },
            },
            // 订单进度-车辆物流信息
            {
                path: '/logisticsVehicleInfo',
                name: 'logisticsVehicleInfo',
                component: () => import('@/views/salesTerminal/orderSituation/logisticsVehicleInfo/index.vue'),
            },

            // 三维
            {
                path: '/threeDimensional',
                name: 'threeDimensional',
                component: () => import('@/views/threeDimensional/index.vue'),
            },

            // 生产配比
            {
                path: '/productionRatio',
                name: 'productionRatio',
                component: () => import('@/views/salesTerminal/productionRatio/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'production-ratio',
                    hierarchy: 0,
                },
            },
            // 关联配比
            {
                path: '/correlationRatio',
                name: 'correlationRatio',
                component: () => import('@/views/salesTerminal/productionRatio/correlationRatio.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'correlation-ratio',
                    hierarchy: 1,
                },
            },
            // 料仓配比信息设置
            {
                path: '/matchingInfoSetting',
                name: 'matchingInfoSetting',
                component: () => import('@/views/salesTerminal/productionRatio/matchingInfoSetting.vue'),
            },
            // 选择配比
            {
                path: '/selectRatio',
                name: 'selectRatio',
                component: () => import('@/views/salesTerminal/productionRatio/selectRatio.vue'),
            },
            // 查看试块
            {
                path: '/seeTestBlock',
                name: 'seeTestBlock',
                component: () => import('@/views/salesTerminal/productionRatio/seeTestBlock.vue'),
            },
            // 配比审批意见
            {
                path: '/mixtureRatioApprovalOpinion',
                name: 'mixtureRatioApprovalOpinion',
                component: () => import('@/views/salesTerminal/productionRatio/mixtureRatioApprovalOpinion.vue'),
            },
            // 配比查看
            {
                path: '/correlationRatio_see',
                name: 'correlationRatio_see',
                component: () => import('@/views/salesTerminal/productionRatio/correlationRatio_see.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'correlation-ratio-see',
                    hierarchy: 1,
                },
            },
            // 配比同步
            {
                path: '/synchronization',
                name: 'synchronization',
                component: () => import('@/views/salesTerminal/productionRatio/synchronization.vue'),
            },

            // 配比审批列表
            {
                path: '/matchingApproval',
                name: 'matchingApproval',
                component: () => import('@/views/salesTerminal/matchingApproval/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'matching-approval',
                    hierarchy: 0,
                },
            },
            // 配比审批
            {
                path: '/matchingApprovalView',
                name: 'matchingApprovalView',
                component: () => import('@/views/salesTerminal/matchingApproval/matchingApprovalView.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'matching-approval-view',
                    hierarchy: 2,
                },
            },


            // 合同授信
            {
                path: '/contractCredit',
                name: 'contractCredit',
                component: () => import('@/views/salesTerminal/contractCredit/index.vue'),
            },

            // 账务确认-列表
            {
                path: '/accountConfirmList',
                name: 'accountConfirmList',
                component: () => import('@/views/salesTerminal/accountConfirm/list.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'account-confirm-list',
                    hierarchy: 0,
                },
            },
            // 账务确认-历史记录列表
            {
                path: '/accountConfirmHistoryList',
                name: 'accountConfirmHistoryList',
                component: () => import('@/views/salesTerminal/accountConfirm/historyList.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'account-confirm-history-list',
                    hierarchy: 1,
                },
            },
            // 账务确认-详情
            {
                path: '/accountConfirmInfo',
                name: 'accountConfirmInfo',
                component: () => import('@/views/salesTerminal/accountConfirm/accountConfirmInfo.vue'),
            },

            // 试块登记-列表
            {
                path: '/blockRegisterList',
                name: 'blockRegisterList',
                component: () => import('@/views/salesTerminal/blockRegister/list.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'block-register-list',
                    hierarchy: 0,
                },
            },
            // 试块登记-试块-列表
            {
                path: '/blockRegisterChildlist',
                name: 'blockRegisterChildlist',
                component: () => import('@/views/salesTerminal/blockRegister/blockList.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'block-register-childlist',
                    hierarchy: 1,
                },
            },
            // 试块登记-试块-编辑
            {
                path: '/editBlock',
                name: 'editBlock',
                component: () => import('@/views/salesTerminal/blockRegister/editBlock.vue'),
            },


            // 监控预警
            {
                path: '/monitorEarlyWarning',
                name: 'monitorEarlyWarning',
                component: () => import('@/views/salesTerminal/monitorEarlyWarning/index.vue'),
            },
            // 物流监控
            {
                path: '/logisticsMonitoring',
                name: 'logisticsMonitoring',
                component: () => import('@/views/salesTerminal/logisticsMonitoring/vehicleLogisticsMonitoring.vue'),
            },
            // 物流监控(场站)
            {
                path: '/logisticsMonitoringStation',
                name: 'logisticsMonitoringStation',
                component: () => import('@/views/salesTerminal/logisticsMonitoring/vehicleLogisticsMonitoring.vue'),
            },
            // 视频监控列表
            {
                path: '/monitoringList',
                name: 'monitoringList',
                component: () => import('@/views/salesTerminal/monitoringList/index.vue'),
            },
            // 视频监控
            {
                path: '/surveillance',
                name: 'surveillance',
                component: () => import('@/views/salesTerminal/monitoringList/surveillance.vue'),
            },
            // 异常打料
            {
                path: '/abnormalProduction',
                name: 'abnormalProduction',
                component: () => import('@/views/salesTerminal/abnormalProduction/index.vue'),
            },
            // 异常配比
            {
                path: '/abnormalMix',
                name: 'abnormalMix',
                component: () => import('@/views/salesTerminal/abnormalMix/index.vue'),
            },
            // 预约排队
            {
                path: '/appointmentQueueMap',
                name: 'appointmentQueueMap',
                component: () => import('@/views/salesTerminal/appointmentQueue/map.vue'),
            },
            // 预约排队
            {
                path: '/appointmentQueueList',
                name: 'appointmentQueueList',
                component: () => import('@/views/salesTerminal/appointmentQueue/list.vue'),
            },
            // 零售账款确认
            {
                path: '/retailAuditlist',
                name: 'retailAuditlist',
                component: () => import('@/views/salesTerminal/retailAudit/auditList.vue'),
            },
            /** 济宁app **/
            // 总经理快报
            {
                path: '/presidentReport',
                name: 'presidentReport',
                component: () => import('@/views/jnApp/default.vue'),
            },
            // 车辆快报
            {
                path: '/vehicleReport',
                name: 'vehicleReport',
                component: () => import('@/views/jnApp/vehicleReport/vehicleDaily.vue'),
            },
            // 销售快报
            {
                path: '/jnSalesReport',
                name: 'jnSalesReport',
                component: () => import('@/views/jnApp/salesReport/default.vue'),
            },
            // 客户应收
            {
                path: '/jnCustomerReceive',
                name: 'jnCustomerReceive',
                component: () => import('@/views/jnApp/customerReceive/list.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'jn-customer-receive',
                    hierarchy: 0,
                },
            },
            // 客户应收-合同详情
            {
                path: '/jnCustomerReceiveDetail',
                name: 'jnCustomerReceiveDetail',
                component: () => import('@/views/jnApp/customerReceive/detail.vue'),
            },
            // 配比消耗
            {
                path: '/matchingConsumption',
                name: 'matchingConsumption',
                component: () => import('@/views/jnApp/matchingConsumption/index.vue'),
            },
            // 生产快报
            {
                path: '/productionExpress',
                name: 'productionExpress',
                component: () => import('@/views/jnApp/productionExpress/index.vue'),
            },
            // 应付账款
            {
                path: '/accountsPayable',
                name: 'accountsPayable',
                component: () => import('@/views/jnApp/accountsPayable/index.vue'),
            },
            // 供应商应付-原材料供应商
            {
                path: '/supplierPayable',
                name: 'supplierPayable',
                component: () => import('@/views/jnApp/supplierPayable/rawMaterialSupplier/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'supplier-payable',
                    hierarchy: 0,
                },
            },
            // 原材料供应商-合同详情
            {
                path: '/supplierContract',
                name: 'supplierContract',
                component: () => import('@/views/jnApp/supplierPayable/rawMaterialSupplier/supplierContract.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'supplier-contract',
                    hierarchy: 1,
                },
            },
            // 原材料供应商-原材料
            {
                path: '/materialDetails',
                name: 'materialDetails',
                component: () => import('@/views/jnApp/supplierPayable/rawMaterialSupplier/materialDetails.vue'),
            },

            // 车辆统计
            {
                path: '/carUseStatis',
                name: 'carUseStatis',
                component: () => import('@/views/salesTerminal/carUseStatis/index.vue'),
            },

            // 供应单列表
            {
                path: '/supplyList',
                name: 'supplyList',
                component: () => import('@/views/customerTerminal/supplyList/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'supplylist',
                    hierarchy: 0,
                },
            },
            // 供应单调价
            {
                path: '/supplyAdjust',
                name: 'supplyAdjust',
                component: () => import('@/views/customerTerminal/supplyList/adjust.vue'),
            },
            // 磅单列表
            {
                path: '/poundList',
                name: 'poundList',
                component: () => import('@/views/supplierTerminal/poundList.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'pound-list',
                    hierarchy: 1,
                },
            },
            // 磅单详情
            {
                path: '/poundDetail',
                name: 'poundDetail',
                component: () => import('@/views/supplierTerminal/poundDetail.vue'),
            },


            {
                path: '/faultList', // 故障报备
                name: 'faultList',
                component: () => import('@/views/leaderTerminal/faultReporting/faultList.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'fault-list',
                    hierarchy: 0,
                },
            },
            {
                path: '/faultDetail', // 查看故障报备
                name: 'faultDetail',
                component: () => import('@/views/driverTerminal/faultReporting/faultDetail.vue'),
            },
            {
                path: '/feedbackResult', // 反馈处理结果
                name: 'feedbackResult',
                component: () => import('@/views/driverTerminal/faultReporting/feedbackResult.vue'),
            },
            {
                path: '/carPosition', // 车辆位置
                name: 'carPosition',
                component: () => import('@/views/driverTerminal/faultReporting/carPosition.vue'),
            },


            // 收款记录
            {
                path: '/collectionRecord',
                name: 'collectionRecord',
                component: () => import('@/views/salesTerminal/collectionRecord/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'collection-record',
                    hierarchy: 0,
                },
            },
            // 收款记录子列表
            {
                path: '/recordList',
                name: 'recordList',
                component: () => import('@/views/salesTerminal/collectionRecord/recordList.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'record-list',
                    hierarchy: 1,
                },
            },
            // 记录关联
            {
                path: '/recordAssociation',
                name: 'recordAssociation',
                component: () => import('@/views/salesTerminal/collectionRecord/recordAssociation.vue'),
            },
            // 新增/编辑收款记录
            {
                path: '/addCollectionRecord',
                name: 'addCollectionRecord',
                component: () => import('@/views/salesTerminal/collectionRecord/addCollectionRecord.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'add-collection-record',
                    hierarchy: 2,
                },
            },
            // 新增/编辑收款记录-选择合同
            {
                path: '/collectionSelectContract',
                name: 'collectionSelectContract',
                component: () => import('@/views/salesTerminal/collectionRecord/collectionSelectContract.vue'),
            },


            // 泵车派发
            {
                path: '/pumpTruckDistribution',
                name: 'pumpTruckDistribution',
                component: () => import('@/views/salesTerminal/pumpTruckDistribution/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'pump-truck-distribution',
                    hierarchy: 0,
                },
            },
            // 添加泵车公司
            {
                path: '/addPumpTruckCompany',
                name: 'addPumpTruckCompany',
                component: () => import('@/views/salesTerminal/pumpTruckDistribution/addPumpTruckCompany.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'add-pump-truck-company',
                    hierarchy: 1,
                },
            },
            // 选择泵车公司
            {
                path: '/selectPumpTruckCompany',
                name: 'selectPumpTruckCompany',
                component: () => import('@/views/salesTerminal/pumpTruckDistribution/selectPumpTruckCompany.vue'),
            },

            // 供应计划[2022/02/23]
            {
                path: '/supplyPlan',
                name: 'supplyPlan',
                component: () => import('@/views/salesTerminal/supplyPlan/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'supply-plan',
                    hierarchy: 0,
                },
            },
            // 供应计划-计划详情
            {
                path: '/planDetails',
                name: 'planDetails',
                component: () => import('@/views/salesTerminal/supplyPlan/planDetails.vue'),
            },
            // 原生上传测试
            {
                path: '/httpUpload',
                name: 'httpUpload',
                component: () => import('@/views/salesTerminal/test/httpUpload.vue'),
            },
        ],
    }, {
        // 领导端
        name: 10,
        router: [
            {
                // 领导端新首页
                path: '/home',
                name: 'home',
                component: () => import('@/views/home/new_home_ld.vue'),
            },
            {
                // 领导端首页
                path: '/inHome',
                name: 'inHome',
                component: () => import('@/views/home/home_ld.vue'),
            },
            {
                // 产销概况
                path: '/market',
                name: 'market',
                component: () => import('@/views/leaderTerminal/reportForm/marketing.vue'),
            }, {
                // 产销概况 - 按结构
                path: '/structure',
                name: 'structure',
                component: () => import('@/views/leaderTerminal/reportForm/marketingChild/structure.vue'),
            }, {
                // 产销概况 - 按趋势
                path: '/byTrend',
                name: 'byTrend',
                component: () => import('@/views/leaderTerminal/reportForm/marketingChild/byTrend.vue'),
            },
            {
                // 物资采购
                path: '/materialPurchase',
                name: 'materialPurchase',
                component: () => import('@/views/leaderTerminal/reportForm/materialPurchase.vue'),
            },
            {
                // 库存情况
                path: '/stock',
                name: 'stock',
                component: () => import('@/views/leaderTerminal/reportForm/stock.vue'),
            },
            {
                // 应付情况
                path: '/payable',
                name: 'payable',
                component: () => import('@/views/leaderTerminal/reportForm/payable.vue'),
            },
            {
                // 生产成本
                path: '/cost',
                name: 'cost',
                component: () => import('@/views/leaderTerminal/reportForm/cost.vue'),
            },
            {
                // 生产成本
                path: '/costDirectMaterials',
                name: 'costDirectMaterials',
                component: () => import('@/views/leaderTerminal/reportForm/costDirectMaterials.vue'),
            },
            {
                // 资产使用
                path: '/assetUse',
                name: 'assetUse',
                component: () => import('@/views/leaderTerminal/reportForm/assetUse.vue'),
            },
            {
                // 回款情况
                path: '/moneyBack',
                name: 'moneyBack',
                component: () => import('@/views/leaderTerminal/reportForm/moneyBack.vue'),
            },
            {
                // 产品流向
                path: '/productFlowTo',
                name: 'productFlowTo',
                component: () => import('@/views/leaderTerminal/reportForm/productFlowTo.vue'),
            },
            // 数据快报-销售日报
            {
                path: '/dataBulletin',
                name: 'dataBulletin',
                component: () => import('@/views/leaderTerminal/DataBulletin/Default.vue'),
            },

            // 合同审批
            {
                path: '/contractApproval',
                name: 'contractApproval',
                component: () => import('@/views/salesTerminal/contractApproval/index.vue'),
                meta: {
                    keepAlive: true,
                    componentName: 'contract-approval',
                    hierarchy: 0,
                },
            },
            // 审批办理
            {
                path: '/approvalProcess',
                name: 'approvalProcess',
                component: () => import('@/views/salesTerminal/contractApproval/approvalProcess.vue'),
                meta: {
                    keepAlive: true,
                    componentName: 'approval-process',
                    hierarchy: 1,
                },
            },
            // 表单预览
            {
                path: '/formPreview',
                name: 'formPreview',
                component: () => import('@/views/salesTerminal/salesComponents/FormView.vue'),
            },
            // 提交
            {
                path: '/submission',
                name: 'submission',
                component: () => import('@/views/salesTerminal/contractApproval/submission.vue'),
            },
            // 审批意见
            {
                path: '/approvalComments',
                name: 'approvalComments',
                component: () => import('@/views/salesTerminal/contractApproval/approvalComments.vue'),
            },
            // 附件预览
            {
                path: '/attachmentPreview',
                name: 'attachmentPreview',
                component: () => import('@/views/salesTerminal/salesComponents/attachmentPreview.vue'),
            },
            // 数据快报
            {
                path: '/dataReport',
                name: 'dataReport',
                component: () => import('@/views/leaderTerminal/dataReport/index.vue'),
            },
            //  数据销售快报
            {
                path: '/dataSalesReport',
                name: 'dataSalesReport',
                component: () => import('@/views/leaderTerminal/dataReport/salesReport/default.vue'),
            },
            //  数据生产快报
            {
                path: '/dataProductionReport',
                name: 'dataProductionReport',
                component: () => import('@/views/leaderTerminal/dataReport/productionReport/index.vue'),
            },
            //  数据配比消耗
            {
                path: '/dataMatchingConsumption',
                name: 'dataMatchingConsumption',
                component: () => import('@/views/leaderTerminal/dataReport/matchingConsumption/index.vue'),
            },
            //  数据客户应收
            {
                path: '/dataCustomerReceive',
                name: 'dataCustomerReceive',
                component: () => import('@/views/leaderTerminal/dataReport/customerReceive/list.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'data-customer-receive',
                    hierarchy: 0,
                },
            },
            //  数据客户应收 合同详情
            {
                path: '/dataCustomerReceiveDetail',
                name: 'dataCustomerReceiveDetail',
                component: () => import('@/views/leaderTerminal/dataReport/customerReceive/detail.vue'),
            },
            //  数据供应商应付
            {
                path: '/dataSupplierPayable',
                name: 'dataSupplierPayable',
                component: () => import('@/views/leaderTerminal/dataReport/supplierPayable/rawMaterialSupplier/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'data-supplier-payable',
                    hierarchy: 0,
                },
            },
            {
                path: '/dataSupplierContract',
                name: 'dataSupplierContract',
                component: () => import('@/views/leaderTerminal/dataReport/supplierPayable/rawMaterialSupplier/supplierContract.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'data-supplier-contract',
                    hierarchy: 0,
                },
            },
            {
                path: '/dataMaterialDetails',
                name: 'dataMaterialDetails',
                component: () => import('@/views/leaderTerminal/dataReport/supplierPayable/rawMaterialSupplier/materialDetails.vue'),
            },
            // 经营驾驶舱地图
            {
                path: '/leadingCockpitMap',
                name: 'leadingCockpitMap',
                component: () => import('@/views/leaderTerminal/leadingCockpit/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'leading-cockit-map',
                    hierarchy: 0,
                },
            },
            // 年累计销量
            {
                path: '/yearAmount',
                name: 'yearAmount',
                component: () => import('@/views/leaderTerminal/leadingCockpit/amount.vue'),
            },
            // 年平均价
            {
                path: '/yearPrice',
                name: 'yearPrice',
                component: () => import('@/views/leaderTerminal/leadingCockpit/price.vue'),
            },
            // 年平均单方成本detail-year-profit
            {
                path: '/yearCost',
                name: 'yearCost',
                component: () => import('@/views/leaderTerminal/leadingCockpit/cost.vue'),
            },
            // 本年度毛利额
            {
                path: '/yearProfit',
                name: 'yearProfit',
                component: () => import('@/views/leaderTerminal/leadingCockpit/profit.vue'),
            },
            // 应收款余额
            {
                path: '/yearKuan',
                name: 'yearKuan',
                component: () => import('@/views/leaderTerminal/leadingCockpit/kuan.vue'),
            },
            // 超发申请-新增
            {
                path: '/newOverApplication',
                name: 'newOverApplication',
                component: () => import('@/views/salesTerminal/overApplication/newOverApplication.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'new-over-application',
                    hierarchy: 1,
                },
            },
            // 新超限发货表单
            {
                path: '/overrunDeliverGoodsForm',
                name: 'overrunDeliverGoodsForm',
                component: () => import('@/views/salesTerminal/overApplication/overrunDeliverGoodsForm.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'overrun-deliver-goods-form',
                    hierarchy: 1,
                },
            },
        ],
    }, {
        // 司机端
        name: 2,
        router: [
            {
                path: '/home',
                name: 'home',
                component: () => import('@/views/home/home_sj.vue'),
            }, {
                path: '/workOrder', // 司机接单-任务单
                name: 'workOrder',
                component: () => import('@/views/driverTerminal/driverReceiveOrder/workOrder.vue'),
            },
            {
                path: '/punchImageList', // 司机接单-任务单-开始打料图片列表
                name: 'punchImageList',
                component: () => import('@/views/driverTerminal/driverReceiveOrder/punchImageList.vue'),
            },
            {
                path: '/vehicleQueue', // 车辆排队
                name: 'vehicleQueue',
                component: () => import('@/views/driverTerminal/vehicleQueue/vehicleQueue.vue'),
            },
            {
                path: '/electronicTicket', // 电子运单
                name: 'electronicTicket',
                component: () => import('@/views/driverTerminal/driverReceiveOrder/electronicTicket.vue'),
            },
            {
                path: '/newTransSheet', // 交付评价-新增
                name: 'newTransSheet',
                component: () => import('@/views/driverTerminal/driverReceiveOrder/newTransSheet.vue'),
            },
            {
                path: '/transSheetInfo', // 交付评价-详情
                name: 'transSheetInfo',
                component: () => import('@/views/driverTerminal/driverReceiveOrder/transSheetInfo.vue'),
            },
            {
                path: '/transSheet', // 交付评价-运输单列表
                name: 'transSheet',
                component: () => import('@/views/driverTerminal/driverReceiveOrder/transSheet.vue'),
            },
            {
                path: '/trainsCostQuery', // 趟费查询
                name: 'trainsCostQuery',
                component: () => import('@/views/driverTerminal/trainsCostQuery/trainsCostQuery.vue'),
            },
            {
                path: '/carManage', // 出车管理-司机打卡
                name: 'carManage',
                component: () => import('@/views/driverTerminal/carManage/carManage.vue'),
            },
            {
                path: '/timeKeeping', // 出车管理-考勤统计
                name: 'timeKeeping',
                component: () => import('@/views/driverTerminal/carManage/timeKeeping.vue'),
            },
            // 查看定位
            {
                path: '/locationInfo',
                name: 'locationInfo',
                component: () => import('@/views/map/locationInfo.vue'),
            },
            {
                path: '/calendar', // 出车管理-打卡月历
                name: 'calendar',
                component: () => import('@/views/driverTerminal/carManage/calendar.vue'),
            },
            {
                path: '/clockInAddress', // 出车管理-查看定位
                name: 'clockInAddress',
                component: () => import('@/views/driverTerminal/carManage/clockInAddress.vue'),
            },
            {
                path: '/faultList', // 故障报备
                name: 'faultList',
                component: () => import('@/views/driverTerminal/faultReporting/faultList.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'fault-list',
                    hierarchy: 0,
                },
            },
            {
                path: '/faultForm', // 添加故障报备
                name: 'faultForm',
                component: () => import('@/views/driverTerminal/faultReporting/faultForm.vue'),
            },
            {
                path: '/faultDetail', // 查看故障报备
                name: 'faultDetail',
                component: () => import('@/views/driverTerminal/faultReporting/faultDetail.vue'),
            },
            {
                path: '/feedbackResult', // 反馈处理结果
                name: 'feedbackResult',
                component: () => import('@/views/driverTerminal/faultReporting/feedbackResult.vue'),
            },
            {
                path: '/carPosition', // 车辆位置
                name: 'carPosition',
                component: () => import('@/views/driverTerminal/faultReporting/carPosition.vue'),
            },
        ],
    }, {
        // 客户端
        name: 3,
        router: [
            {
                path: '/home',
                name: 'home',
                component: () => import('@/views/home/home_kh.vue'),
            }, {
                path: '/materialPlan', // 用料计划-列表
                name: 'materialPlan',
                component: () => import('@/views/customerTerminal/materialPlan/materialPlan.vue'),
            },
            {
                path: '/newMaterialPlan', // 新增用料计划
                name: 'newMaterialPlan',
                component: () => import('@/views/customerTerminal/materialPlan/newMaterialPlan.vue'),
            },
            {
                path: '/materialPlanInfo', // 用料计划详情
                name: 'materialPlanInfo',
                component: () => import('@/views/customerTerminal/materialPlan/materialPlanInfo.vue'),
            },
            {
                path: '/selectProject', // 选择工程
                name: 'selectProject',
                component: () => import('@/views/customerTerminal/materialPlan/selectProject.vue'),
            },
            {
                path: '/selectConstructionEnterprise', // 选择施工单位
                name: 'selectConstructionEnterprise',
                component: () => import('@/views/customerTerminal/materialPlan/selectConstructionEnterprise.vue'),
            },
            {
                path: '/selectMonomer', // 选择单体
                name: 'selectMonomer',
                component: () => import('@/views/customerTerminal/materialPlan/selectMonomer.vue'),
            },
            {
                path: '/transSheet', // 交付评价-运输单列表
                name: 'transSheet',
                component: () => import('@/views/customerTerminal/materialPlan/transSheet.vue'),
            },
            {
                path: '/newTransSheet', // 新增评价
                name: 'newTransSheet',
                component: () => import('@/views/customerTerminal/materialPlan/newTransSheet.vue'),
            },
            {
                path: '/transSheetInfo', // 评价详情
                name: 'transSheetInfo',
                component: () => import('@/views/customerTerminal/materialPlan/transSheetInfo.vue'),
            },
            {
                path: '/electronicTicket', // 电子运单
                name: 'electronicTicket',
                component: () => import('@/views/customerTerminal/materialPlan/electronicTicket.vue'),
            },
            {
                path: '/projectAddress', // 工程信息
                name: 'projectAddress',
                component: () => import('@/views/customerTerminal/materialPlan/projectAddress.vue'),
            },
            {
                // 意见反馈-列表
                path: '/feedbackList',
                name: 'feedbackList',
                component: () => import('@/views/customerTerminal/feedback/list.vue'),
            },
            {
                // 意见反馈-新增
                path: '/newFeedback',
                name: 'newFeedback',
                component: () => import('@/views/customerTerminal/feedback/newFeedback.vue'),
            },
            {
                // 意见反馈-选取合同
                path: '/selectContract',
                name: 'selectContract',
                component: () => import('@/views/customerTerminal/feedback/selectContract.vue'),
            },
            {
                // 意见反馈-详情
                path: '/feedbackInfo',
                name: 'feedbackInfo',
                component: () => import('@/views/customerTerminal/feedback/feedbackInfo.vue'),
            },
            // 订单进度-列表
            {
                path: '/orderSituationList',
                name: 'orderSituationList',
                component: () => import('@/views/customerTerminal/orderSituation/orderList/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'order-situation-list',
                    hierarchy: 0,
                },
            },
            // 订单进度-运输单列表
            {
                path: '/transOrderlist',
                name: 'transOrderlist',
                component: () => import('@/views/customerTerminal/orderSituation/transOrderlist.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'trans-orderlist',
                    hierarchy: 1,
                },
            },
            // 订单进度-车辆物流信息
            {
                path: '/logisticsVehicleInfo',
                name: 'logisticsVehicleInfo',
                component: () => import('@/views/customerTerminal/orderSituation/logisticsVehicleInfo/index.vue'),
            },
            {
                path: '/supplyList', // 供应单列表
                name: 'supplyList',
                component: () => import('@/views/customerTerminal/supplyList/index.vue'),
            },
            {
                path: '/supplyAdjust', // 供应单调价
                name: 'supplyAdjust',
                component: () => import('@/views/customerTerminal/supplyList/adjust.vue'),
            },
            {
                path: '/contractProgress',
                name: 'contractProgress',
                component: () => import('@/views/customerTerminal/contractProgress/index.vue'),
            },
        ],
    }, {
        // 供应商
        name: 4,
        router: [
            {
                path: '/home', // 首页
                name: 'home',
                component: () => import('@/views/home/home_gys.vue'),
            },
            {
                path: '/orderTakingList', // 接单列表
                name: 'orderTakingList',
                component: () => import('@/views/supplierTerminal/orderTakingList.vue'),
            },
            {
                path: '/orderRefuse', // 拒绝接单
                name: 'orderRefuse',
                component: () => import('@/views/supplierTerminal/orderRefuse.vue'),
            },
            {
                path: '/FeedbackList', // 反馈列表
                name: 'FeedbackList',
                component: () => import('@/views/supplierTerminal/FeedbackList.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'feedback-list',
                    hierarchy: 0,
                },
            },
            {
                path: '/FeedbackSubmit', // 提交反馈
                name: 'FeedbackSubmit',
                component: () => import('@/views/supplierTerminal/FeedbackSubmit.vue'),
            },
            {
                path: '/driverList', // 司机列表
                name: 'driverList',
                component: () => import('@/views/supplierTerminal/driverList.vue'),
            },
            {
                path: '/driverAdd', // 添加司机
                name: 'driverAdd',
                component: () => import('@/views/supplierTerminal/driverAdd.vue'),
            },
            {
                path: '/driverEdit', // 修改司机
                name: 'driverEdit',
                component: () => import('@/views/supplierTerminal/driverEdit.vue'),
            },
            {
                path: '/affirmList', // 供应单确认
                name: 'affirmList',
                component: () => import('@/views/supplierTerminal/affirmList.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'affirm-list',
                    hierarchy: 0,
                },
            },
            {
                path: '/poundList', // 磅单列表
                name: 'poundList',
                component: () => import('@/views/supplierTerminal/poundList.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'pound-list',
                    hierarchy: 1,
                },
            },
            {
                path: '/poundDetail', // 磅单详情
                name: 'poundDetail',
                component: () => import('@/views/supplierTerminal/poundDetail.vue'),
            },
            {
                path: '/priceChange', // 价格变更
                name: 'priceChange',
                component: () => import('@/views/supplierTerminal/priceChange/index.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'price-change',
                    hierarchy: 1,
                },
            },
            {
                path: '/priceChangeDetails', // 价格变更详情
                name: 'priceChangeDetails',
                component: () => import('@/views/supplierTerminal/priceChange/priceChangeDetails.vue'),
            },
            {
                path: '/newPriceAdjustment', // 新增，编辑调价
                name: 'newPriceAdjustment',
                component: () => import('@/views/supplierTerminal/priceChange/newPriceAdjustment.vue'),
                meta: {
                    keepAlive: true, // 需要缓存
                    componentName: 'new-price-adjustment',
                    hierarchy: 2,
                },
            },
            {
                path: '/selectContract', // 新增，编辑调价-选择合同
                name: 'selectContract',
                component: () => import('@/views/supplierTerminal/priceChange/selectContract.vue'),
            },
            {
                path: '/selectMaterials', // 新增，编辑调价-选择原材料
                name: 'selectMaterials',
                component: () => import('@/views/supplierTerminal/priceChange/selectMaterials.vue'),
            },
        ],
    }, {
        // 运输单位
        name: 5,
        router: [
            {
                path: '/home', // 首页
                name: 'home',
                component: () => import('@/views/home/home_gys.vue'),
            },
            {
                path: '/orderTakingList', // 接单列表
                name: 'orderTakingList',
                component: () => import('@/views/supplierTerminal/orderTakingList.vue'),
            },
            {
                path: '/orderRefuse', // 拒绝接单
                name: 'orderRefuse',
                component: () => import('@/views/supplierTerminal/orderRefuse.vue'),
            },
            {
                path: '/FeedbackList', // 反馈列表
                name: 'FeedbackList',
                component: () => import('@/views/supplierTerminal/FeedbackList.vue'),
            },
            {
                path: '/FeedbackSubmit', // 提交反馈
                name: 'FeedbackSubmit',
                component: () => import('@/views/supplierTerminal/FeedbackSubmit.vue'),
            },
            {
                path: '/driverList', // 司机列表
                name: 'driverList',
                component: () => import('@/views/supplierTerminal/driverList.vue'),
            },
            {
                path: '/driverAdd', // 添加司机
                name: 'driverAdd',
                component: () => import('@/views/supplierTerminal/driverAdd.vue'),
            },
            {
                path: '/driverEdit', // 修改司机
                name: 'driverEdit',
                component: () => import('@/views/supplierTerminal/driverEdit.vue'),
            },
            {
                path: '/affirmList', // 供应单确认
                name: 'affirmList',
                component: () => import('@/views/supplierTerminal/affirmList.vue'),
            },
            {
                path: '/poundList', // 磅单列表
                name: 'poundList',
                component: () => import('@/views/supplierTerminal/poundList.vue'),
            },
            {
                path: '/poundDetail', // 磅单详情
                name: 'poundDetail',
                component: () => import('@/views/supplierTerminal/poundDetail.vue'),
            },
        ],
    }, {
        // 我的
        name: 'my',
        router: [{
            // 关于我们
            path: '/home',
            name: 'home',
            component: () => import('@/views/public/aboutUs.vue'),
            meta: {
                hideBottomTabBar: true, // 是否隐藏底部标签栏
            },
        }, {
            // 用户协议
            path: '/agreement',
            name: 'agreement',
            component: () => import('@/views/public/agreement.vue'),
        }, {
            // 隐私条款
            path: '/privacy',
            name: 'privacy',
            component: () => import('@/views/public/privacy.vue'),
        }],
    }, {
        // 系统通知
        name: 'systemNotification',
        router: [
            {
                path: '/home',
                name: 'home',
                component: () => import('@/views/public/systemNotification.vue'),
            },
            // 附件预览
            {
                path: '/messageAttachment',
                name: 'messageAttachment',
                component: () => import('@/views/salesTerminal/salesComponents/attachmentPreview.vue'),
            },
        ],
    },
];
